
























































import { Component, Mixins } from 'vue-property-decorator'
import IconsMixin from '@/mixins/IconsMixin.vue'
import AuthMixin from '@/mixins/AuthMixin.vue'
import LabeledValue from '@/components/LabeledValue.vue'
import {
  Company,
  CompanyCollection,
  CompanyTypeEnum,
  Order,
  OrderCollection,
  OrderEntry,
  PriceList,
  PriceListCollection
} from 'serverless-firestore'
import { DateService } from '@/services/date.service'

@Component({
  components: { LabeledValue }
})
export default class LoadingDockList extends Mixins(IconsMixin, AuthMixin) {
  public vendors: Company[] = []
  public orders: Order[] = []
  public priceLists: PriceList[] = []

  public showCheckedIn: boolean = false

  public headers = [
    { text: '', sortable: false, value: 'icon' },
    { text: 'Order #', value: 'number' },
    { text: 'Vendor', value: 'assignedCompanyId' },
    { text: 'Date Expected', value: 'dateExpected' },
    { text: 'Status', value: 'status' }
  ]

  public months = DateService.months('abbreviatedMonths')

  public get filteredOrders() {
    const filtered = this.orders.filter(
      (order) =>
        this.showCheckedIn
        || !order.isComplete
    )
    filtered.sort((a: Order, b: Order) => {
      if (!a.dateExpected) {
        return 1
      } else if (!b.dateExpected) {
        return -1
      } else {
        return b.dateExpected.getTime() - a.dateExpected.getTime()
      }
    })

    return filtered
  }

  public async mounted() {
    const collection = new OrderCollection(( await this.$firebase ).firestore())
    this.orders = collection.watchVendorOrdersByRestaurantId(this.userCompany.id)

    const companyCollection = new CompanyCollection(( await this.$firebase ).firestore())
    this.vendors = companyCollection.watchCompaniesByType(CompanyTypeEnum.VENDOR)

    const priceListCollection = new PriceListCollection(( await this.$firebase ).firestore())
    this.priceLists = priceListCollection.watchPriceListsByCompanyId(this.userCompany.id, CompanyTypeEnum.RESTAURANT)
  }

  public lookupVendorName(vendorCompanyId: string, entries: OrderEntry[]): string {
    const vendor = this.vendors.find((c: Company) => c.id === vendorCompanyId)
    return vendor ? vendor.displayName + this.lookupRepName(entries) : ''
  }

  public lookupRepName(entries: OrderEntry[]): string {
    const entry = entries.find(entry => entry.priceListId)

    if(entry && entry.priceListId) {
      const priceList = this.lookupPriceList(entry.priceListId)
      if(priceList && priceList.vendorRepName) {
        return ` - ${priceList.vendorRepName}`
      }
    }

    return ''
  }

  public lookupPriceList(id: string): PriceList {
    const priceList = this.priceLists.find(
      priceList => priceList.id === id
    )

    return priceList ? priceList : {} as PriceList
  }

  public convertToHeader(group: number) {
    if(!group || group === 1000000) {
      return 'No Date Found'
    }

    return `${this.months[parseInt(group.toString().slice(4)) - 1]} ${group.toString().slice(0, 4)}`
  }

  public async viewOrder(order: Order) {
    await this.$router.push({ name: 'receiving-details', params: { id: order.id } })
  }
}
